import { combineReducers } from 'redux';
import app from './AppReducer';
import flyer from './FlyerReducer';

const rootReducer = combineReducers({
  app,
  flyer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/state/reducers.ts